//Styles
import { Wrapper, Content } from "./ErrorHandler.styles";

const ErrorHandler = ({ error }) => (
    <Wrapper>
        <Content>
            <h1>{error ? "Something went wrong..." : "Page not found"}</h1>
        </Content>
    </Wrapper>
);

export default ErrorHandler;
